import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HorizontalMenuItems } from 'app/core/menu/menu-items/horizontal-menu-items';
import { MenuItems } from 'app/core/menu/menu-items/menu-items';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import PerfectScrollbar from 'perfect-scrollbar';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { UserService } from 'app/services/user/user.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { AuthService } from 'app/services/auth.service';
declare var require: any
const screenfull = require('screenfull');

@Component({
   selector: 'ms-dashboard-layout',
   templateUrl: './dashboard-layout.component.html',
   styleUrls: ['./dashboard-layout.component.css']
})
export class DashboardLayoutComponent implements OnInit {
   private _router: Subscription;
   header: string;
   currentLang = 'it';
   url: string;
   showSettings = false;
   dark: boolean;
   boxed: boolean;
   horizontalMenu: boolean;
   collapseSidebar: boolean;
   compactSidebar: boolean;
   customizerIn: boolean = false;
   headerGreen: boolean = false;
   headerRed: boolean = false;
   headerYellow: boolean = false;
   root = 'ltr';
   myroot = 'ltr';
   collapsedClass: any = 'side-panel-opened';
   chatpanelOpen: boolean = false;
   themeHeaderSkinColor: any = "header-default";
   themeSidebarSkinColor: any = "sidebar-default";
   userName: string = '';
   roleName:any;

   private _mediaSubscription: Subscription;
   sidenavOpen: boolean = true;
   sidenavMode: string = 'side';
   isMobile: boolean = false;
   private _routerEventsSubscription: Subscription;

   @ViewChild('sidenav', { static: true }) sidenav;

   public config: PerfectScrollbarConfigInterface = {};
   constructor(
      public menuItems: MenuItems,
      public horizontalMenuItems: HorizontalMenuItems,
      private pageTitleService: PageTitleService,
      public translate: TranslateService,
      private router: Router,
      private media: MediaObserver,
      private userService: UserService,
      private commonUtilService: CommonUtilService,
      private spinnerService: SpinnerService,
      private auth: AuthService) {

   }

   ngOnInit() {

      this.spinnerService.start();

      this.translate.use('it');

      this.pageTitleService.title.subscribe((val: string) => {
         this.header = val;
      });

      this._router = this.router.events.pipe(
         filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
         this.url = event.url;
      });

      if (this.url != '/session/login' && this.url != '/session/register' && this.url != '/session/forgot-password' && this.url != '/session/lockscreen') {
         const elemSidebar = <HTMLElement>document.querySelector('.sidebar-container ');

         if (window.matchMedia(`(min-width: 960px)`).matches) {
            // Ps.initialize(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
            if (elemSidebar != null) {
               const ps = new PerfectScrollbar(elemSidebar, {
                  wheelSpeed: 2,
                  suppressScrollX: true
               });
            }

         }
      }
      if (this.media.isActive('xs') || this.media.isActive('sm')) {
         this.sidenavMode = 'over';
         this.sidenavOpen = false;

      }
      this._mediaSubscription = this.media.media$.subscribe((change: MediaChange) => {
         let isMobile = (change.mqAlias == 'xs') || (change.mqAlias == 'sm');

         this.isMobile = isMobile;
         this.sidenavMode = (isMobile) ? 'over' : 'side';
         this.sidenavOpen = !isMobile;
      });

      this._routerEventsSubscription = this.router.events.subscribe((event) => {
         if (event instanceof NavigationEnd && this.isMobile) {
            this.sidenav.close();
         }
      });

      if(this.auth.isAdmin()){
         this.userService.getAdminDetail().subscribe(data => {
            if(data && data.firstName && data.lastName){
               this.userName = data.firstName.concat(" ").concat(data.lastName);
            }
         })
         this.roleName = "Amministratore";
      } else {
         this.userService.getPersonalDetail().subscribe(data => {
            if(data && data.firstName && data.lastName){
               this.userName = data.firstName.concat(" ").concat(data.lastName);
            }
         });
         this.roleName = "Hr Utente";
      }

      this.spinnerService.stop();

   }

   ngOnDestroy() {
      this._router.unsubscribe();
      this._mediaSubscription.unsubscribe();
   }

   isFullscreen: boolean = false;

   menuMouseOver(): void {
      if (window.matchMedia(`(min-width: 960px)`).matches && this.collapseSidebar) {
         this.sidenav.mode = 'over';
      }
   }

   menuMouseOut(): void {
      if (window.matchMedia(`(min-width: 960px)`).matches && this.collapseSidebar) {
         this.sidenav.mode = 'side';
      }
   }

   toggleFullscreen() {
      if (screenfull.enabled) {
         screenfull.toggle();
         this.isFullscreen = !this.isFullscreen;
      }
   }

   customizerFunction() {
      this.customizerIn = !this.customizerIn;
   }
   headerSkinColorFunction(color) {
      this.themeHeaderSkinColor = color;
   }
   sidebarSkinColorFunction(color) {
      this.themeSidebarSkinColor = color;
   }
   menuToggleFunc() {
      this.sidenav.toggle();

      if (this.collapsedClass == 'side-panel-opened') {
         this.collapsedClass = 'side-panel-closed';
      }
      else {
         this.collapsedClass = 'side-panel-opened';
      }
   }

   /* 
   use this case when using module enable
   
   addMenuItem(): void {
      this.menuItems.add({
         state: 'pages',
         name: 'SILK MENU',
         type: 'sub',
         icon: 'trending_flat',
         children: [
            { state: 'blank', name: 'SUB MENU1' },
            { state: 'blank', name: 'SUB MENU2' }
         ]
      });
   } */

   onActivate(e, scrollContainer) {
      scrollContainer.scrollTop = 0;
   }

   logOut() {
      this.spinnerService.start();
      this.commonUtilService.logout();
   }

}
